import { render, staticRenderFns } from "./PractitionerAnnualReturnsTask.vue?vue&type=template&id=7b7fd4c5&scoped=true&"
import script from "./PractitionerAnnualReturnsTask.vue?vue&type=script&lang=js&"
export * from "./PractitionerAnnualReturnsTask.vue?vue&type=script&lang=js&"
import style0 from "./PractitionerAnnualReturnsTask.vue?vue&type=style&index=0&id=7b7fd4c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7fd4c5",
  null
  
)

export default component.exports